// extracted by mini-css-extract-plugin
export default {"footer":"_4wgj0"};